// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1bGnZ","label":"Category_label__cJAGX","content":"Category_content__3Wdox","header":"Category_header___wdgv","location":"Category_location__2Qp81"};